import React, { useEffect, useState } from 'react';
import { Provider } from 'mobx-react';
import { Router, RouterStore } from 'react-router-mobx';
import { BrowserRouter } from 'react-router-dom';
import './style/index.scss';
import { ModalComponent } from './components/modal';
import Routes from './routes';
import RootStore from './common/stores';

import setCssVariables from './hooks/useCssVariable';

const rootStore = new RootStore();
const routerStore = new RouterStore();

function App() {
  const [store, setStore] = useState(rootStore);

  useEffect(() => {
    const mobileArr = ['iPhone', 'iPod', 'BlackBerry', 'Android', 'Windows CE', 'LG', 'MOT', 'SAMSUNG', 'SonyEricsson'];
    let mobileDevice = '';

    for (let txt in mobileArr) {
      if (navigator.userAgent.match(mobileArr[txt]) != null) {
        mobileDevice = mobileArr[txt];
        break;
      }
    }

    window.reflowOnFocus = () => {
      if (navigator.userAgent.indexOf('chrome') && (mobileDevice === 'iPhone' || mobileDevice === 'iPod')) {
        document.getElementById('for-reflow').focus();
      }
    };
  }, []);

  // Set CSS variables for icons and images
  useEffect(() => {
    const host = window.location.host;
    let mainHost = 'named.com';
    if (
      host.includes('nmd.co') ||
      host.includes('xn--950bo4em5v.co') ||
      host.includes('named.net') ||
      host.includes('named2.net') ||
      host.includes('named2.kr')
    ) {
      mainHost = host.match(/nmd\.co|xn--950bo4em5v\.co|named\.net|named2\.net|named2\.kr/)[0];
    }
    setCssVariables({
      'sport-main-icon': `url('https://image.${mainHost}/portal/new_sp_main_icons.png')`,
      'sport-attend-icon': `url('https://${mainHost}/img/page/attend/sp_attend_v15031117.png')`,
      'img-gwango-center': `url('https://image.${mainHost}/portal/img_gwango_center.png')`,
    });
  }, []);

  return (
    <Provider {...store}>
      <Router component={BrowserRouter} routerStore={routerStore}>
        <Routes />
      </Router>
      <ModalComponent />
      <input
        id={'for-reflow'}
        onFocus={(event) => {
          event.currentTarget.blur();
        }}
      />
    </Provider>
  );
}

export default App;
